// removed by extract-text-webpack-plugin
module.exports = {"timelineChart":"antd-pro-charts--timeline-chart-timelineChart"};


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/src/components/Charts/TimelineChart/index.less
// module id = 1062
// module chunks = 0